import React from 'react';
import { Button, Typography } from 'components';
import { useLabelPrint } from './useLabelPrint';
import { PDFViewer } from './PDFViewer';
import styles from './styles.module.scss';

const { Title } = Typography;

export const LabelPrint: React.FC = () => {
  const { isLoading, labelData, isDownloadingNote, handlePrintDeliveryNote, handlePrintLabel } = useLabelPrint();

  if (isLoading || !labelData) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingContainer}>
          <Typography.Text>Loading...</Typography.Text>
        </div>
      </div>
    );
  }

  const fileUrl = labelData.files?.ATTACHMENTS;
  const fileExtension = labelData.extension?.toLowerCase();
  const isImage = ['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(fileExtension || '');
  const isPDF = fileExtension === 'pdf';

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Title level={3} className={styles.pageTitle}>
          Your Package is complete
        </Title>

        {/* Label File Display */}
        {fileUrl && (
          <div className={styles.labelFileContainer}>
            {isImage && <img src={fileUrl} alt="Generated Label" className={styles.labelImage} />}
            {isPDF && <PDFViewer url={fileUrl} />}
          </div>
        )}
      </div>

      {/* Fixed Bottom Action Buttons */}
      <div className={styles.bottomActions}>
        <Button type="default" size="large" onClick={handlePrintDeliveryNote} loading={isDownloadingNote} block>
          Print Delivery Note
        </Button>
        <Button type="primary" size="large" onClick={handlePrintLabel} block>
          Print Label
        </Button>
      </div>
    </div>
  );
};
